import React from "react";
import { useNavigate } from "react-router-dom";
import styles from "./modules/Logout.module.scss";

const Logout = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("jwtToken"); // Clear the token
    navigate("/login"); // Redirect to login page
  };

  return (
    <button onClick={handleLogout} className={styles.logoutButton}>
      Logout
    </button>
  );
};

export default Logout;
